import { render, staticRenderFns } from "./DetailReceipt.vue?vue&type=template&id=740d524d&scoped=true&"
import script from "./DetailReceipt.vue?vue&type=script&lang=js&"
export * from "./DetailReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d524d",
  null
  
)

export default component.exports